import {
  Checkbox,
  DialogActions,
  FormControlLabel,
  IconButton,
  InputAdornment,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";
import { PeopleAltOutlined } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination } from "@material-ui/lab";
import cn from "classnames";
import ButtonComponent from "components/Button";
import Flex from "components/Flex";
import TagPreviewItem from "components/TagPreviewItem";
import _ from "lodash";
import { useEffect, useState, useRef } from "react";
import { X } from "react-feather";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { selectFanpageSelected } from "views/Customer/CustomerSelectors";
import fanpageApi from "../../api/fanpageApi";
import { showError, showSuccess } from "../../stores/alert/slice.alert";
import CustomersInFBTagModal from "../CustomersInTagModal/CustomersInFBTagModal";
import styles from "../../views/Tag/TagView.module.scss";

const useStyles = makeStyles({
  widthCheckBox: {
    height: "52px"
  },
  widthSeq: {
    minWidth: "80px",
    padding: "0 8px !important"
  },
  widthId: {
    minWidth: "146px",
    padding: "0 8px !important"
  },
  widthName: {
    minWidth: "220px",
    padding: "0 8px !important"
  },
  widthCreatedAt: {
    minWidth: "220px",
    padding: "0 8px !important"
  },
  widthCreatedBy: {
    minWidth: "220px",
    padding: "0 8px !important"
  },
  widthQuantityCus: {
    minWidth: "120px",
    padding: "0 8px !important"
  },
  widthActions: {
    minWidth: "140px",
    width: "6%",
    padding: "0 8px !important"
  },
  p0: {
    padding: "0",
    margin: "0"
  },
  heightHeader: {
    height: "52px"
  },
  f600: {
    fontWeight: 600
  },
  checkBoxPadding: {
    padding: "10px 20px"
  },
  actions: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginTop: "10px"
  },
  closeBtn: {
    color: "#ffffff",
    backgroundColor: "#dc3545",
    border: "2px solid #dc3545",
    padding: "6px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#c82333",
      borderColor: "#bd2130"
    }
  },
  submitBtn: {
    color: "white",
    backgroundColor: "#28a745",
    border: "2px solid #28a745",
    padding: "6px 26px",
    borderRadius: "4px",
    cursor: "pointer",
    margin: "0 36px !important",
    "&:hover": {
      backgroundColor: "#218838",
      borderColor: "#1e7e34"
    }
  },
  numCusInp: {
    fontSize: "14px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
  },
  footerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 26px",
    margin: "12px 0",
    minHeight: "48px"
  },
  container: {
    flex: 1,
    width: "100%"
  },
  paginationBottom: {
    display: "flex !important",
    justifyContent: "end !important",
    alignItems: "center !important"
  },
  buttonLoadMore: {
    alignItems: "center",
    appearance: "none",
    backgroundColor: "#fff",
    border: "1px solid #dbdbdb",
    borderRadius: ".375em",
    boxShadow: "none",
    boxSizing: "border-box",
    color: "#363636",
    cursor: "pointer",
    display: "inline-flex",
    fontFamily: `BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    fontSize: "0.8rem",
    height: "1.8em",
    justifyContent: "center",
    lineHeight: "1.5",
    padding: "calc(.5em - 1px) 1em",
    position: "relative",
    textAlign: "center",
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "manipulation",
    verticalAlign: "top",
    whiteSpace: "nowrap",
    "&:hover": {
      borderColor: "#b5b5b5"
    },
    "&:active": {
      borderColor: "#4a4a4a",
      outline: "0"
    },
    "&:focus": {
      borderColor: "#485fc7",
      outline: "0"
    },
    "&:focus:not(:active)": {
      boxShadow: "rgba(72, 95, 199, 0.25) 0 0 0 0.125em"
    }
  },
  rowItem: {
    cursor: "pointer"
  },

  noData: {
    color: "rgba(0,0,0,.5)",
    fontWeight: "bold",
    textAlign: "center",
    padding: "24px"
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#637381",
    padding: "8px",
    marginRight: "8px",
    "&:hover": {
      color: "#212B36",
      backgroundColor: "rgba(99, 115, 129, 0.08)",
      borderRadius: "50%"
    }
  },
  dialogTitle: {
    position: "relative",
    paddingRight: "48px",
    margin: 0,
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
});

const countRowPerPages = 10;

const resolveTotalPages = (data) => {
  const pageSize = data?.size > 0 ? data.size : countRowPerPages;
  const fromElements = Math.ceil((Number(data?.totalElements) || 0) / pageSize);
  const fromApi = Number(data?.totalPages);
  return Math.max(Number.isFinite(fromApi) ? fromApi : 0, fromElements);
};

const buildPageList = (current, total) => {
  if (total <= 7) return Array.from({ length: Math.max(total, 0) }, (_, i) => i);
  const pages = [];
  const addPage = (p) => { if (!pages.includes(p)) pages.push(p); };
  addPage(0);
  addPage(total - 1);
  for (let i = Math.max(0, current - 1); i <= Math.min(total - 1, current + 1); i++) addPage(i);
  pages.sort((a, b) => a - b);
  const result = [];
  pages.forEach((p, idx) => {
    if (idx > 0 && p - pages[idx - 1] > 1) result.push(-1);
    result.push(p);
  });
  return result;
};

export const tagType = {
  BOMBOT_TAGS: "BOMBOT_TAGS",
  FACEBOOK_TAGS: "FACEBOOK_TAGS"
};

const FbTagsManagement = ({ getData, getFanpage, onDataLoad, filter = 'ALL', onFilterChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const pageSelected = useSelector(selectFanpageSelected);
  const [page, setPage] = useState(0);
  const [fbTagData, setFbTagData] = useState([]);
  const [checkedList, setCheckedList] = useState({});
  const [searchVal, setSearchVal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [isOpenRenameModal, setIsOpenRenameModal] = useState(false);
  const [renameSelected, setRenameSelected] = useState(null);
  const [toastMsg, setToastMsg] = useState(null);
  const toastTimer = useRef(null);
  const pageIdRef = useRef(pageSelected?.id);
  pageIdRef.current = pageSelected?.id;
  const pageRef = useRef(page);
  pageRef.current = page;

  const dispatch = useDispatch();

  const getFbTags = async (page) => {
    if (!pageSelected.id) return;

    let search = null;

    if (searchVal.trim()) {
      search = `id|name==${searchVal}`;
    }

    let params = {
      id: pageSelected.id,
      page: page,
      size: countRowPerPages
    };

    if (!_.isNull(search)) {
      params = {
        id: pageSelected.id,
        page: page,
        size: countRowPerPages,
        search
      };
    }

    const fanpageId = pageSelected.id;
    const requestPage = page;
    return fanpageApi
      .getFbTagList(fanpageId, params)
      .then((res) => {
        if (fanpageId !== pageIdRef.current || requestPage !== pageRef.current) return res;
        setFbTagData(res);
        if (onDataLoad && res?.statistic) {
          const statistic = res.statistic;
          onDataLoad({
            total: statistic.total ?? 0,
            used: statistic.used ?? 0,
            empty: statistic.empty ?? 0,
          });
        }
        const totalPages = resolveTotalPages(res);
        if (requestPage > 0 && !(res?.content?.length) && requestPage >= totalPages) {
          setPage(Math.max(totalPages - 1, 0));
        }
        return res;
      });
  };

  useEffect(() => {
    setPage(0);
  }, [pageSelected?.id]);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        await getFbTags(page);
      } catch (error) {
        dispatch(showError(t('setting_account.tag_error_generic')));
      } finally {
        setIsLoading(false);
      }
    })();
  }, [pageSelected?.id, page]);

  // useDebounce(
  //   () => {
  //     ;(async () => {
  //       setIsLoading(true)
  //       try {
  //         setPage(0)
  //         if (!searchVal.trim()) {
  //           await getBombotTags(0)
  //           return
  //         }
  //         const res = await fanpageApi.searchTags(pageSelected?.id, {
  //           id: pageSelected.id,
  //           page: 0,
  //           size: countRowPerPages,
  //           search: `name==${searchVal}`,
  //         })
  //         setTagData(res)
  //       } catch (error) {
  //         dispatch(showError('Co loi xay ra!'))
  //       } finally {
  //         setIsLoading(false)
  //       }
  //     })()
  //   },
  //   500,
  //   [searchVal]
  // )

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      setPage(0);
      await getFbTags(0);

      // const res = await fanpageApi.searchBombotTags(pageSelected?.id, {
      //   id: pageSelected.id,
      //   page: 0,
      //   size: countRowPerPages,
      //   search: `name==${searchVal}`,
      // })
      // setBombotTagData(res)
    } catch (error) {
      dispatch(showError(t('setting_account.tag_error_generic')));
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCheckAllTag = (isChecked) => {
    const currentPageTags = fbTagData?.content;
    let checkListTmp = { ...checkedList };
    currentPageTags.forEach((tag) => {
      checkListTmp[tag.id] = isChecked;
    });
    setCheckedList(checkListTmp);
  };

  const handleCheckTag = (isChecked, tagId) => {
    setCheckedList((prev) => ({
      ...prev,
      [tagId]: isChecked
    }));
  };

  const handleDeleteSearch = () => {
    setSearchVal("");
    setPage(0);
  };

  const handleSubmitDeleteTags = () => {
    if (Object.keys(checkedList).length === 0) {
      dispatch(showError(t('setting_account.tag_error_select_least_one')));
      return;
    }
    setOpenConfirmDelete(true);
  };

  const handleDeleteTags = async () => {
    setIsLoading(true);
    try {
      await fanpageApi.deleteBomBotTagList(pageSelected?.id, {
        tagId: Object.keys(checkedList)
      });

      getFanpage();
      getData();

      await getFbTags();

      setOpenConfirmDelete(false);
      dispatch(
        showSuccess(t('setting_account.tag_delete_success', { count: Object.keys(checkedList).length }))
      );
      setCheckedList({});
    } catch (error) {
      dispatch(showError(t('setting_account.tag_delete_fail')));
    } finally {
      setIsLoading(false);
    }
  };

  const handleRenameTag = async (renameTag, newName) => {
    try {
      const payload = {
        name: newName
      };

      await fanpageApi.renameTag(pageSelected.id, renameTag.id, payload);

      getFanpage();
      getData();

      await getFbTags();
    } catch (error) {
      console.log(error);
    } finally {
      setRenameSelected(null);
    }
  };

  const copyText = (text, e) => {
    e.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(String(text));
      setToastMsg(t('tag_page.copy_id_toast', { id: text }));
      if (toastTimer.current) clearTimeout(toastTimer.current);
      toastTimer.current = setTimeout(() => setToastMsg(null), 2500);
    }
  };

  return (
    <>
      <div className={styles.toolbar}>
        <div className={styles.searchWrap}>
          <svg viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="4.5"/><path d="M13.5 13.5l-3-3"/></svg>
          <input
            className={styles.searchInput}
            type="text"
            placeholder={t('tag_page.search_placeholder')}
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
          />
          {searchVal && (
            <button className={`${styles.searchClear} ${styles.show}`} onClick={handleDeleteSearch}>
              <svg viewBox="0 0 10 10" fill="none"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"/></svg>
            </button>
          )}
        </div>
        <select className={styles.sortSelect} defaultValue="countDesc">
          <option value="countDesc">{t('tag_page.sort_most_cus')}</option>
          <option value="countAsc">{t('tag_page.sort_least_cus')}</option>
          <option value="nameAsc">{t('tag_page.sort_name_az')}</option>
        </select>
      </div>

      <div className={styles.tblScroll}>
        <table className={styles.customTable}>
          <thead>
            <tr>
              <th style={{ minWidth: 260 }}>{t('tag_page.col_tag')}</th>
              <th>{t('tag_page.col_type')}</th>
              <th className={styles.thNum} style={{ width: 120 }}>{t('tag_page.col_customers')}</th>
              <th style={{ textAlign: 'right', width: 140 }}>{t('tag_page.col_action')}</th>
            </tr>
          </thead>
          <tbody>
            {fbTagData?.content?.length > 0 ? (
              fbTagData.content.filter(tag => {
                if (filter === 'ACTIVE') return (tag.totalCus || 0) > 0;
                if (filter === 'EMPTY') return (tag.totalCus || 0) === 0;
                return true;
              }).map((tag, index) => (
                <tr key={tag.id} className={styles.tagRow}>
                  <td>
                    <div className={styles.tagCell}>
                      <div className={`${styles.tagChip} ${styles.tFb}`}>
                        <svg viewBox="0 0 14 14" fill="none"><path d="M9.5 1.5H8A2.5 2.5 0 005.5 4v1.5H4V8h1.5v4.5H8V8h1.5l.5-2.5H8V4.3c0-.5.3-.8.8-.8h1.2V1.5z"/></svg>
                        <span title={tag.name}>{tag.name}</span>
                      </div>
                      <div className={styles.tagId}>
                        ID {tag.id}
                        <button className={styles.copyBtn} title={t('setting_account.tag_copy_id_tooltip')} onClick={(e) => copyText(tag.id, e)}>
                          <svg viewBox="0 0 12 12" fill="none"><rect x="3" y="3" width="7" height="7" rx="1"/><path d="M2 8V2h6"/></svg>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className={`${styles.typeBadge} ${styles.typeFb}`}>
                      {t('tag_page.type_facebook')}
                    </div>
                  </td>
                  <td className={styles.tdNum}>
                    <div className={styles.countCell}>
                      {(tag.totalCus === 0 || !tag.totalCus) && <span className={styles.emptyFlag}>{t('tag_page.empty_flag')}</span>}
                      <span className={`${styles.countVal} ${!tag.totalCus ? styles.zero : ""}`}>
                        {tag.totalCus || 0}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className={styles.rowActions}>
                      <button className={styles.btnRow} onClick={() => setSelectedTag(tag)}>
                        <svg viewBox="0 0 15 15" fill="none"><circle cx="6" cy="5" r="2.5"/><path d="M1.5 13c0-2.8 2-4.5 4.5-4.5s4.5 1.7 4.5 4.5"/><path d="M10.5 1.8a2.5 2.5 0 010 4.9M13 13c0-2.2-1.3-3.8-3-4.3"/></svg>
                        {t('tag_page.view_customers')}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">
                  <div className={styles.tblEmpty}>
                    <div className={styles.tblEmptyIcon}>
                      <svg viewBox="0 0 20 20" fill="none"><circle cx="9" cy="9" r="6"/><path d="M17 17l-4-4"/></svg>
                    </div>
                    <div className={styles.tblEmptyTitle}>{t("update.no_data")}</div>
                    <div className={styles.tblEmptySub}>{t('tag_page.empty_sub_facebook')}</div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!_.isNull(selectedTag) && (
        <CustomersInFBTagModal
          isOpen={!_.isNull(selectedTag)}
          handleClose={() => setSelectedTag(null)}
          tagId={selectedTag?.id}
          tag={selectedTag}
        />
      )}

      {fbTagData?.content?.length > 0 && (() => {
        const totalPages = resolveTotalPages(fbTagData);

        return (
          <div className={styles.tblFooter}>
            <span className={styles.tblCount}>{t('tag_page.total_count', { count: fbTagData?.totalElements || 0 })}</span>
            <div className={styles.pagination}>
              <button
                className={styles.pgBtn}
                disabled={page === 0}
                onClick={() => handleChangePage(null, page - 1)}
                aria-label={t('tag_page.pg_prev')}
              >
                <svg viewBox="0 0 12 12" fill="none"><path d="M8 2L4 6l4 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>

              {buildPageList(page, totalPages).map((p, idx) =>
                p === -1
                  ? <span key={`ellipsis-${idx}`} className={styles.pgBtn} style={{ border: 'none', background: 'none', cursor: 'default', minWidth: 24 }}>…</span>
                  : <button
                      key={p}
                      className={`${styles.pgBtn} ${p === page ? styles.on : ''}`}
                      onClick={() => handleChangePage(null, p)}
                    >
                      {p + 1}
                    </button>
              )}

              <button
                className={styles.pgBtn}
                disabled={page >= totalPages - 1}
                onClick={() => handleChangePage(null, page + 1)}
                aria-label={t('tag_page.pg_next')}
              >
                <svg viewBox="0 0 12 12" fill="none"><path d="M4 2l4 4-4 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            </div>
          </div>
        );
      })()}

      {/* Toast Copy */}
      <div className={`${styles.toast} ${toastMsg ? styles.show : ''}`}>
        <svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5l3 3 6-6.5"/></svg>
        {toastMsg}
      </div>
    </>
  );
};

const CellSticky = styled(TableCell)`
  position: sticky;
  background-color: #fff;
  right: -1px;
  z-index: 2;
  box-shadow: -15px 0px 17px -7px #f0eded;
  top: 0; 
`;

export default FbTagsManagement;
